//TODO: Musi poczekać, bo jest zależne od innych modułów w tej libce
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

type ProductInventoryLevelInternalItem = {
    readonly id: number;
    readonly unitId: number;
    readonly quantity: number;
} | null;

export class ProductInventoryLevelQuery extends Query<ProductInventoryLevelInternalItem> {
    public constructor(public readonly id: number) {
        super();
    }
}

export class ProductInventoryLevelQueryHandlerBase implements QueryHandler<ProductInventoryLevelQuery, ProductInventoryLevelInternalItem> {
    private static Url = TaggedUrl.join('products/:id/inventory/level', [Tags.Api, Tags.NotHandle404]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: ProductInventoryLevelQuery): Promise<ProductInventoryLevelInternalItem> {
        const url = fillPlaceholders(ProductInventoryLevelQueryHandlerBase.Url, { id: query.id });
        return await this.http.get<ProductInventoryLevelInternalItem>(url).then(result => result.data, () => null);
    }
}
